import React from "react";
import { AuthProvider } from "./auth/AuthProvider";
import Layout from "./components/Layout";
import Home from "./pages/Home";

export default function App() {
  return (
    <AuthProvider>
      <Layout>
        <Home />
      </Layout>
    </AuthProvider>
  );
}